// External Dependencies:
import 'es6-promise/auto'

export function addScript( value ) {
	return {
		type: 'ADD_SCRIPT',
		value: value
	}
}

export function openMenu() {
	return {
		type: 'OPEN_MENU'
	}
}

export function closeMenu() {
	return {
		type: 'CLOSE_MENU'
	}
}

export function setSidebarVisibility( val ) {
	return {
		type: 'SET_SIDEBAR_VISIBILITY',
		payload: val
	}
}

export function acceptCatCheck() {
	localStorage.setItem( 'hasAcceptedCatsCheck', '1' )

	return {
		type: 'ACCEPT_CAT_CHECK'
	}
}

export function acceptDogCheck() {
	localStorage.setItem( 'hasAcceptedDogsCheck', '1' )

	return {
		type: 'ACCEPT_DOG_CHECK'
	}
}



// WEBPACK FOOTER //
// ./redux/actions/site.jsx